import React from 'react';
import styled from 'styled-components';

export const Input = ({
  children,
  ...props
}: React.PropsWithChildren<React.InputHTMLAttributes<HTMLInputElement>>) => (
  <Container {...props}>{children}</Container>
);

const Container = styled.input`
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.color.ui.shade2};
  background: ${(props) => props.theme.color.bg.primary};
  box-shadow: 0px 0px 0px 0px #cbdafc;
  padding: 0px 12px;
  height: 48px;
  color: ${(props) => props.theme.color.text.primary};
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  &::placeholder {
    color: ${(props) => props.theme.color.text.disabled};
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: ${(props) => props.theme.color.bg.muted};
  }
`;
